import { getStore } from '../store/store';

export default function getActiveProxyAddresses() {
    const { availableProxyAddresses } = getStore();
    const activeProxyAddresses = [];
    if (availableProxyAddresses) {
        availableProxyAddresses.forEach((enabled, address) => {
            if (enabled) {
                activeProxyAddresses.push(address);
            }
        });
    }
    return activeProxyAddresses;
}
